import DepsService from 'services/dependencies';
import appHelpers from 'app/app-helpers';

const CONTEXT = 'bondRenewal';

export const downloadBondRenewalReport = (extension, retailerId) => {
  const url = DepsService.rest.widgets.bondRenewal.url;
  const queryParams = {};
  const urlParams = { retailerId };
  const headers = appHelpers.setHeader(extension);

  return DepsService.restSrv.downloadBlob(CONTEXT, url, queryParams, urlParams, headers);
};

export const fetchBondRenewal = async ({ retailerId, bondRenewalMaxDaysNo }) => {
  const url = DepsService.rest.widgets.bondRenewal.url;
  const queryParams = { days: bondRenewalMaxDaysNo };
  const urlParams = { retailerId };

  const stores = await DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);

  return {
    stores: storeTransformation(stores, bondRenewalMaxDaysNo),
    storeCount: stores.length,
  };
};

export const storeTransformation = (stores, bondRenewalMaxDaysNo) => {
  return stores.reduce((aggregated, store) => {
    let arr = aggregated[store.bondRenewalDaysLeft] || [];

    aggregated[store.bondRenewalDaysLeft] = [
      ...arr,
      ...[
        {
          ...store,
          percentExpirationDays: appHelpers.calculateDaysLeftToPercentages(store.bondRenewalDaysLeft, bondRenewalMaxDaysNo),
        },
      ],
    ];

    return aggregated;
  }, {});
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/bond-renewal.api.js